import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-video-download",
  "use": "icon-video-download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-video-download\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.49709 9.40299L10.861 7.03909L11.5681 7.7462L8.35348 10.9608L7.99993 11.3144L7.64638 10.9608L4.43177 7.7462L5.13888 7.03909L7.49709 9.3973V1.32084H8.49709V9.40299ZM14.9292 7.74994V14.1792V14.6792H14.4292H1.57077H1.07077V14.1792V7.75291H2.07077V13.6792H13.9292V7.74994H14.9292Z\" fill=\"#323232\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol